import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import ResetIcon from "@mui/icons-material/RestartAlt";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { useConfigurationAttributeEditableUnit } from "@plansoft-configuration-renderer/framework";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
/**
 * Returns InputProps for Input component
 *
 * Currently used to
 * -  add input start and end adornments for unit and reset button
 * @param options
 * @returns
 */
export function useEditInputProps(options) {
    const { handleReset, showReset } = options;
    const unitText = useConfigurationAttributeEditableUnit({ mode: "symbol" });
    const t = useUiTranslator();
    const resetButton = showReset ? (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { onClick: handleReset, title: t("ConfigurationRenderer:Actions.resetAttribute", "Reset"), children: _jsx(ResetIcon, {}) }) })) : undefined;
    const unitAdornment = unitText ? (_jsx(InputAdornment, { position: "end", children: unitText })) : undefined;
    // could contain multiple adornments
    const startAdornment = undefined;
    // could contain multiple adornments
    const endAdornment = unitAdornment || resetButton ? (_jsxs(Fragment, { children: [unitAdornment, resetButton] })) : undefined;
    return {
        startAdornment,
        endAdornment,
    };
}
//# sourceMappingURL=useEditInputProps.js.map